import { render, staticRenderFns } from "./RoomInfoH5.vue?vue&type=template&id=59041222&scoped=true"
import script from "./RoomInfoH5.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoomInfoH5.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RoomInfoH5.vue?vue&type=style&index=0&id=59041222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59041222",
  null
  
)

export default component.exports